<script setup lang="ts">
import { ref,reactive,computed, onMounted,onBeforeUnmount } from 'vue'
import CustomList from "../../../compositions/CustomList.vue";
import ModalDialog from "../../../compositions/ModalDialog.vue";
import CsvLoader from "../../../compositions/CsvLoader.vue";
import SearchBox from "../../../compositions/SearchBox.vue";
import SelectBox from "../../../compositions/SelectBox.vue";
import TextBox from "../../../compositions/TextBox.vue";
import CheckBox from "../../../compositions/CheckBox.vue";
import PharmacyMedicineEditComponent from "../../Common/PharmacyMedicineEditComponent.vue";
import MedicineHistoryDetailComponent from "../../Common/MedicineHistoryDetailComponent.vue";
import PharmacyGroupListComponent from "../../Common/PharmacyGroupListComponent.vue";
import PharmacyMedicineTagComponent from "../../Common/PharmacyMedicineTagComponent.vue";
import config from "../../../config.js";
import { getFieldValue } from "../../../plugins/utility";
import { getHeadMedicineMark } from "../../../plugins/pharmacy";
import { errorAlert,confirmAlert,successAlert } from "../../../plugins/alert";
import qs from 'qs';
import axios from '../../../plugins/axios.ts';
import HelpAction from '../../../compositions/HelpAction.vue';
import { useStockStore } from '../../../stores/stock';
import Breakpoint from '../../../compositions/Breakpoint.vue';
import moment from "moment";

const stock = useStockStore();

const props = defineProps({
    apis:{
      type:Object,
      required:true,
    },
    pharmacyWholesalers:{
      type:Array,
      required:true,
    },
    placeHolder:{
        type:String,
        default: () => {
            return '';
        }
    }
})
const headerRef = ref();
const submitRef = ref();
const changeListHeight = () => {
  if (typeof headerRef.value !== 'undefined') {
    listHeight.value = window.innerHeight - document.getElementById('header').clientHeight - document.getElementById('footer').clientHeight - headerRef.value.clientHeight - 5;
    if (typeof submitRef.value !== 'undefined' && isEditedCheck()) {
      listHeight.value -= (submitRef.value.clientHeight - document.getElementById('footer').clientHeight - 5);
    }
    if (listHeight.value < 200) {
      listHeight.value = 200;
    }
  }
  //マージン分引く
  listHeight.value -= 80;
}

const listRef = ref();
const listStockRef = ref();
const listPharmacyRelationRef = ref();
const inputRefs = ref();
const inputDateTimeRefs = ref();
const inputSellRefs = ref();
const inputDeleteRefs = ref();
const listHeight = ref(72);
const searchWord = ref('');
const medicineIds = reactive([]);
const pharmacyTagList = reactive([]);
const pharmacyTagOptions = reactive([]);
const medicineOptions = reactive([]);
const searchDateFrom = ref('');
const searchDateTo = ref('');
const isStockMode = ref(false);
const isDeleteMode = ref(false);
const isSellMode = ref(false);
const isEditLoading = ref(false);
const deleteReasons = reactive([]);
const drugTypes = reactive([]);
//全てはカットする
for (let i=0;i<config.STOCK_REASONS.length;i++) {
  if (config.STOCK_REASONS[i].id == -1) {
    continue;
  }
  deleteReasons.push(config.STOCK_REASONS[i]);
}
const onSearchWordChange = (value) => {
  searchWord.value = value;
}
const onSearchWordEnter = (value) => {
  searchWord.value = value;
  listSearch();
}
const onSearchDateFromChange = (value) => {
  searchDateFrom.value = value;
  listSearch();
}
const onSearchDateToChange = (value) => {
  searchDateTo.value = value;
  listSearch();
}
const editDelete = async () => {
  if (isDeleteMode.value) {
    return;
  }

  if (isSellMode.value) {
    let result = await closeSellConfirm();
    if (result == false) {
      return;
    }
  }
  if (isStockMode.value) {
    let result = await closeStockConfirm();
    if (result == false) {
      return;
    }
  }

  isDeleteMode.value = true;
  listHeight.value = 68;
  controlRow(0,'action_delete');
}

const closeDeleteConfirm = async () => {
  let confirmResult = false;
  if (stock.edit_sell_data.length > 0) {
    let result = await confirmAlert('編集中の内容を削除してもよろしいですか？');
    if (result.isConfirmed) {
      confirmResult = true;
      closeDelete();
    }
  } else {
    confirmResult = true;
    closeDelete();
  }
  return confirmResult;
}
const closeDelete = () => {
  stock.edit_delete_data.splice(0);
  isDeleteMode.value = false;
  listHeight.value = 72;
  controlRow(1,'action_delete');
}

const editStock = async () => {
  if (isStockMode.value) {
    return;
  }
  if (isSellMode.value) {
    let result = await closeSellConfirm();
    if (result == false) {
      return;
    }
  }
  if (isDeleteMode.value) {
    let result = await closeDeleteConfirm();
    if (result == false) {
      return;
    }
  }

  isStockMode.value = true;
  listHeight.value = 68;
  controlRow(0,'action_stock');
}
const closeStockConfirm = async () => {
  let confirmResult = false;
  if (stock.edit_stock_data.length > 0) {
    let result = await confirmAlert('編集中の内容を削除してもよろしいですか？');
    if (result.isConfirmed) {
      confirmResult = true;
      closeStock();
    }
  } else {
    confirmResult = true;
    closeStock();
  }
  return confirmResult;
}
const closeStock = () => {
  stock.edit_stock_data.splice(0);
  isStockMode.value = false;
  listHeight.value = 72;
  controlRow(1,'action_stock');
}

const editSell = async () => {
  if (isSellMode.value) {
    return;
  }
  if (isStockMode.value) {
    let result = await closeStockConfirm();
    if (result == false) {
      return;
    }
  }
  if (isDeleteMode.value) {
    let result = await closeDeleteConfirm();
    if (result == false) {
      return;
    }
  }
  isSellMode.value = true;
  listHeight.value = 68;
  controlRow(0,'action_sell');
}
const closeSellConfirm = async () => {
  let confirmResult = false;
  if (stock.edit_sell_data.length > 0) {
    let result = await confirmAlert('編集中の内容を削除してもよろしいですか？');
    if (result.isConfirmed) {
      confirmResult = true;
      closeSell();
    }
  } else {
    confirmResult = true;
    closeSell();
  }
  return confirmResult;
}
const closeSell = () => {
  stock.edit_sell_data.splice(0);
  isSellMode.value = false;
  listHeight.value = 72;
  controlRow(1,'action_sell');
}

const controlRow = (type,field_key) => {
  if (field_key == 'action_stock') {
    if (type == 0) { //追加
      fields.push({field_name: '', field_key: 'action_stock', width: '30%', align: 'text-center'})
      detailFields.push({field_name: '', field_key: 'action_stock', width: '30%', align: 'text-center'})
    } else { //削除
      for (let i=0;i<fields.length;i++) {
        if (fields[i].field_key == 'action_stock') {
          fields.splice(i,1);
          break;
        }
      }
      for (let i=0;i<detailFields.length;i++) {
        if (detailFields[i].field_key == 'action_stock') {
          detailFields.splice(i,1);
          break;
        }
      }
    }
  } else if (field_key == 'action_sell') {
    if (type == 0) { //追加
      fields.push({field_name: '', field_key: 'action_sell', width: '10%', align: 'text-center'})
      detailFields.push({field_name: '', field_key: 'action_sell', width: '10%', align: 'text-center'})
    } else { //削除
      for (let i=0;i<fields.length;i++) {
        if (fields[i].field_key == 'action_sell') {
          fields.splice(i,1);
          break;
        }
      }
      for (let i=0;i<detailFields.length;i++) {
        if (detailFields[i].field_key == 'action_sell') {
          detailFields.splice(i,1);
          break;
        }
      }
    }
  } else if (field_key == 'action_delete') {
    if (type == 0) { //追加
      fields.push({field_name: '', field_key: 'action_delete', width: '30%', align: 'text-center'})
      detailFields.push({field_name: '', field_key: 'action_delete', width: '30%', align: 'text-center'})
    } else { //削除
      for (let i=0;i<fields.length;i++) {
        if (fields[i].field_key == 'action_delete') {
          fields.splice(i,1);
          break;
        }
      }
      for (let i=0;i<detailFields.length;i++) {
        if (detailFields[i].field_key == 'action_delete') {
          detailFields.splice(i,1);
          break;
        }
      }
    }
  }
}
const fields = reactive([
  {field_name: '採用品<br>', field_key: 'product_name', width: '10%', align: 'text-left', sorted: true},
  {field_name: '分類<br>', field_key: 'warning_mark', width: '3%', align: 'text-center', sorted:true},
  {field_name: '在庫数<br>', field_key: 'real_stock_number', width: '7%', align: 'text-center', sorted: true},
  {field_name: '仮在庫数<br>', field_key: 'stock_number', width: '7%', align: 'text-center', sorted: true},
  {field_name: '包装<br>', field_key: 'package_label', width: '10%', align: 'text-left', sorted: false},
  {field_name: '棚番', field_key: 'storage_bin', width: '5%', align: 'text-center', sorted: true},
  {field_name: '経過措置<br>', field_key: 'transitional_measure_date', width: '5%', align: 'text-center', sorted:true},
  {field_name: '在庫数<br>', field_key: 'medicine_real_stock_number', width: '7%', align: 'text-center', sorted: false},
  {field_name: '仮在庫数<br>', field_key: 'medicine_stock_number', width: '7%', align: 'text-center', sorted: false},
  {field_name: '最終棚卸<br>', field_key: 'latest_inventory_date', width: '5%', align: 'text-center', sorted: true},
  {field_name: '最終入出庫<br>', field_key: 'latest_access_date', width: '5%', align: 'text-center', sorted: true},
  {field_name: '', field_key: 'action_setting', width: '5%', align: 'text-center'},
]);
const mainFields = reactive([
  {field_name: '採用品', field_key: 'product_name', width: '17%', align: 'text-left', sorted: true},
  {field_name: '分類', field_key: 'warning_mark', width: '6%', align: 'text-center', sorted:true},
  {field_name: '在庫数', field_key: 'real_stock_number', width: '10%', align: 'text-center', sorted: true},
  {field_name: '仮在庫数', field_key: 'stock_number', width: '10%', align: 'text-center', sorted: true},
]);
const detailFields = reactive([
  {field_name: '包装', field_key: 'package_label', width: 'w-2/12', align: 'text-left', sorted: false},
  {field_name: '棚番', field_key: 'storage_bin', width: '5%', align: 'text-center', sorted: true},
  {field_name: '経過措置', field_key: 'transitional_measure_date', width: '8%', align: 'text-center', sorted:true},
  {field_name: '在庫数', field_key: 'medicine_real_stock_number', width: '10%', align: 'text-center', sorted: false},
  {field_name: '仮在庫数', field_key: 'medicine_stock_number', width: '10%', align: 'text-center', sorted: false},
  {field_name: '最終棚卸', field_key: 'latest_inventory_date', width: '10%', align: 'text-center', sorted: true},
  {field_name: '最終入出庫', field_key: 'latest_access_date', width: '10%', align: 'text-center', sorted: true},
  {field_name: '', field_key: 'action_setting', width: '5%', align: 'text-center'},
]);
const optionFields = reactive({
  'search_word' : searchWord.value,
  'latest_access_date_from' : searchDateFrom.value,
  'latest_access_date_to' : searchDateTo.value,
  'is_stock' : 1,
  'medicine_ids':medicineIds,
  'tags':pharmacyTagList,
  'page_size' : 30,
});

for (let i=0;i<Object.keys(config.DRUG_TYPES).length;i++) {
  optionFields[Object.keys(config.DRUG_TYPES)[i]] = 0;
}
const listSearch = (delay=0) => {
  optionFields.search_word = searchWord.value;
  optionFields.latest_access_date_from = searchDateFrom.value;
  optionFields.medicine_ids = medicineIds;
  optionFields.tags = pharmacyTagList;
  optionFields.latest_access_date_to = searchDateTo.value;
  for (let i=0;i<Object.keys(config.DRUG_TYPES).length;i++) {
    optionFields[Object.keys(config.DRUG_TYPES)[i]] = 0;
  }
  for (let i=0;i<drugTypes.length;i++) {
    optionFields[drugTypes[i]] = 1;
  }
  listRef.value.resetItem(delay);
}
const handler = (name:string,value:Object,eof:Boolean=false) => {
  if (name == 'item') {
  }
}

const updateDelete = async () => {
  let params = [];
  for (let i=0;i<stock.edit_delete_data.length;i++) {
    params.push({
      medicine_id:stock.edit_delete_data[i].medicine_id,
      delete_number:stock.edit_delete_data[i].delete_number,
      stock_reason:stock.edit_delete_data[i].stock_reason,
      lot_no:stock.edit_delete_data[i].lot_no,
      expire_date:stock.edit_delete_data[i].expire_date,
    });
  }
  isEditLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_stock_update,{method:"post",data:params});
    if (response.data.status == 200) {
      closeDelete();
      listSearch(config.LIST_DELAY);
    }
  } finally {
    isEditLoading.value = false;
  }
}

const updateStock = async () => {
  let params = [];
  let errorFlg = false;
  for (let i=0;i<stock.edit_stock_data.length;i++) {
    if (stock.edit_stock_data[i].stock_datetime.length == 0) {
      errorFlg = true;
      break;
    }
    params.push({
      medicine_id:stock.edit_stock_data[i].medicine_id,
      stock_number:stock.edit_stock_data[i].stock_number,
      lot_no:stock.edit_stock_data[i].lot_no,
      expire_date:stock.edit_stock_data[i].expire_date,
      update_stock_date:stock.edit_stock_data[i].stock_datetime
    });
  }
  if (errorFlg) {
      errorAlert('日時を入力してください。');
      return;
  }
  isEditLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_stock_update,{method:"post",data:params});
    if (response.data.status == 200) {
      closeStock();
      listSearch(config.LIST_DELAY);
    }
  } finally {
    isEditLoading.value = false;
  }
}
const updateSell = async () => {
  isEditLoading.value = true;
  let params = [];
  for (let i=0;i<stock.edit_sell_data.length;i++) {
    params.push({
      medicine_id:stock.edit_sell_data[i].medicine_id,
      reference_unit_price:parseFloat(stock.edit_sell_data[i].reference_unit_price)
    });
  }
  try {
    const response = await axios(props.apis.pharmacy_sell_update,{method:"post",data:params});
    if (response.data.status == 200) {
      closeSell();
      listSearch(config.LIST_DELAY);
    }
  } finally {
    isEditLoading.value = false;
  }
}

const isStockDialog = ref(false);
const stockMedicineId = ref(0);
const stockMedicineYjCode = ref('');
const showStockHistory = (item) => {
  stockMedicineId.value = 0;
  stockMedicineYjCode.value = '';
  if (typeof item.medicine_id !== 'undefined') {
    stockMedicineId.value = item.medicine_id;
  } else {
    stockMedicineYjCode.value = item.yj_code;
  }
  isStockDialog.value = true;
}
const closeStockHistory = () => {
  isStockDialog.value = false;
}
const initDeleteData = (option,field,value) => {
  let result = {medicine_id:option.medicine_id,delete_number:0,stock_reason:0,lot_no:'',expire_date:''}
  result[field] = value;
  return result;
}
const editDeleteTextChange = (value,option) => {
  let exists = false;
  for (let i=0;i<stock.edit_delete_data.length;i++) {
    if (stock.edit_delete_data[i].medicine_id == option.medicine_id) {
      if (value === '') {
        stock.edit_delete_data.splice(i,1);
      } else {
        stock.edit_delete_data[i].delete_number = value;
      }
      exists = true;
      break;
    }
  }
  //空白は追加しない
  if (value === '') {
    return;
  }
  if (exists == false) {
    stock.edit_delete_data.push(initDeleteData(option,'delete_number',value));
  }
}
const editDeleteLotNoTextChange = (value,option) => {
  let exists = false;
  for (let i=0;i<stock.edit_delete_data.length;i++) {
    if (stock.edit_delete_data[i].medicine_id == option.medicine_id) {
      stock.edit_delete_data[i].lot_no = value;
      exists = true;
      break;
    }
  }
  if (exists == false) {
    stock.edit_delete_data.push(initDeleteData(option,'lot_no',value));
  }
}
const editDeleteExpireDateTextChange = (value,option) => {
  let exists = false;
  for (let i=0;i<stock.edit_delete_data.length;i++) {
    if (stock.edit_delete_data[i].medicine_id == option.medicine_id) {
      stock.edit_delete_data[i].expire_date = value;
      exists = true;
      break;
    }
  }
  if (exists == false) {
    stock.edit_delete_data.push(initDeleteData(option,'exipre_date',value));
  }
}
const selectDeleteReasonChange = (value,label,option) => {
  let exists = false;
  for (let i=0;i<stock.edit_delete_data.length;i++) {
    if (stock.edit_delete_data[i].medicine_id == option.medicine_id) {
      stock.edit_delete_data[i].stock_reason = value;
      exists = true;
      break;
    }
  }
  if (exists == false) {
    stock.edit_delete_data.push(initDeleteData(option,'stock_reason',value));
  }
}
const initStockData = (medicineId,option) => {
    let today = new Date();
    return {medicine_id:medicineId,stock_number:'',lot_no:'',expire_date:'',stock_datetime:moment(today).format('YYYY-MM-DD HH:mm:ss')};
}
const editStockTextChange = (value,option) => {
  let exists = false;
  for (let i=0;i<stock.edit_stock_data.length;i++) {
    if (stock.edit_stock_data[i].medicine_id == option.medicine_id) {
      if (value === '') {
        stock.edit_stock_data.splice(i,1);
      } else {
        stock.edit_stock_data[i].stock_number = value;
      }
      exists = true;
      break;
    }
  }
  //空白は追加しない
  if (value === '') {
    return;
  }
  if (exists == false) {
    let record = initStockData(option.medicine_id,option);
    record.stock_number = value;
    stock.edit_stock_data.push(record);
  }
}
const editStockDateTimeChange = (value,option) => {
  let exists = false;
  for (let i=0;i<stock.edit_stock_data.length;i++) {
    if (stock.edit_stock_data[i].medicine_id == option.medicine_id) {
      stock.edit_stock_data[i].stock_datetime = value;
      exists = true;
      break;
    }
  }
  if (exists == false) {
    let record = initStockData(option.medicine_id,option);
    record.stock_datetime = value;
    stock.edit_stock_data.push(record);
  }
}
const editLotNoChange = (value,option) => {
  let exists = false;
  for (let i=0;i<stock.edit_stock_data.length;i++) {
    if (stock.edit_stock_data[i].medicine_id == option.medicine_id) {
      stock.edit_stock_data[i].lot_no = value;
      exists = true;
      break;
    }
  }
  if (exists == false) {
    let record = initStockData(option.medicine_id,option);
    record.lot_no = value;
    stock.edit_stock_data.push(record);
  }
}
const editExpireDateChange = (value,option) => {
  let exists = false;
  for (let i=0;i<stock.edit_stock_data.length;i++) {
    if (stock.edit_stock_data[i].medicine_id == option.medicine_id) {
      stock.edit_stock_data[i].expire_date = value;
      exists = true;
      break;
    }
  }
  if (exists == false) {
    let record = initStockData(option.medicine_id,option);
    record.expire_date = value;
    stock.edit_stock_data.push(record);
  }
}

const editSellTextChange = (value,option) => {
  let exists = false;
  for (let i=0;i<stock.edit_sell_data.length;i++) {
    if (stock.edit_sell_data[i].medicine_id == option.medicine_id) {
      if (value === '') {
        stock.edit_sell_data.splice(i,1);
      } else {
        stock.edit_sell_data[i].reference_unit_price = value;
      }
      exists = true;
      break;
    }
  }
  //空白は追加しない
  if (value === '') {
    return;
  }
  if (exists == false) {
    stock.edit_sell_data.push({medicine_id:option.medicine_id,reference_unit_price:value});
  }
}

const yjCode = ref('');
const isEditPharmacyMedicineDialog = ref(false);
const showEditPharmacyMedicine = (item = null) => {
  if (isEditedCheck()) {
    return;
  }
  if (item != null) {
    yjCode.value = item.yj_code;
  } else {
    yjCode.value = '';
  }
  isEditPharmacyMedicineDialog.value = true;
}
const closeEditPharmacyMedicine = () => {
  isEditPharmacyMedicineDialog.value = false;
  yjCode.value = '';
}
const updateCompleteMedicine = (data) => {
  listSearch(config.LIST_DELAY);
  closeEditPharmacyMedicine();
}
const clearDate = () => {
  searchDateFrom.value = '';
  searchDateTo.value = '';
  listSearch();
}
if (stock.edit_delete_data.length > 0) {
  editDelete()
}
if (stock.edit_stock_data.length > 0) {
  editStock()
}
if (stock.edit_sell_data.length > 0) {
  editSell()
}

const isUploadFileDialog = ref(false);
const isUploadFileLoading = ref(false);
const uploadFile = ref(new Object());
const uploadFileData = ref([]);
const isMedicineType = ref(false);
const updateStockDate = ref('');
const changeUpdateStockDate = (value) => {
  updateStockDate.value = value;
}
const editCheckChange = (value) => {
  isMedicineType.value = value;
}
const uploadFilehandler = (value:Object) => {
  uploadFile.value = value;
}
const uploadStart = () => {
  isUploadFileLoading.value = true;
}
const uploadComplete = (data) => {
  // 表示するために最大30データをセットする
  uploadFileData.value.splice(0);
  for (let i=0;i<data.length;i++) {
    if (i > 30) {
      break;
    }
    uploadFileData.value.push(data[i]);
  }
  isUploadFileLoading.value = false;
  //
}
const showUploadFileDialog = async () => {
  if (isEditedCheck()) {
    return;
  }
  if (isStockMode.value) {
    let confirmResult = await closeStockConfirm();
    if (confirmResult == false) {
      return;
    }
  } else if (isSellMode.value) {
    let confirmResult = await closeSellConfirm();
    if (confirmResult == false) {
      return;
    }
  }
  isUploadFileDialog.value = true;
}
const closeUploadFileDialog = () => {
  isUploadFileDialog.value = false;
}
const uploadFileDataResultConfirm = async () => {
  let result = await confirmAlert('<span style="color:red;">納品されたのにまだ納品確定を行っていない状態で在庫調整を行ってしまうと、在庫のズレが生じます。まだ納品確定を行っていない場合は、納品確定を行ってから在庫調整を行ってください。</span><br><br>在庫調整を行いますか？');
  if (result.isConfirmed) {
    await uploadFileDataResult();
  }
}
const uploadFileDataResult = async () => {
  if (!uploadFile.value) {
    errorAlert('ファイルを選択してください。');
    return;
  }
  if (!updateStockDate.value) {
    errorAlert('棚卸日時を指定してください。');
    return;
  }
  let params = new FormData();
  params.append('upload_file', uploadFile.value);
  params.append('update_stock_date',updateStockDate.value);
  isUploadFileLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_stock_update_file,{method:"post",data:params});
    if (response.data.status == 200) {
      listSearch(config.LIST_DELAY);
      closeUploadFileDialog();
    }
  } finally {
    isUploadFileLoading.value = false;
  }
}

const displayLeave = () => {
  //
}
onBeforeUnmount(() => {
  window.removeEventListener('resize', changeListHeight);
  window.removeEventListener('beforeunload', displayLeave);
});
onMounted(() => {
  window.addEventListener('resize', changeListHeight);
  window.addEventListener('beforeunload', displayLeave);
  setTimeout(changeListHeight,100);
});

const isPharmacyMedicinePackSellDialog = ref(false);
const isPharmacyMedicinePackSellLoading = ref(false);
const pharmacyMedicinePackData = reactive([]);
const pharmacyMedicinePackSellId = ref(0);
const packSellTargetPharmacyId = ref(0);
const packSellTargetPharmacy = reactive([]);
const packSellPharmacyGroupId = ref(-1);
const packSellPharmacyGroupName = ref('');
const packSelleNumber = ref(0);
const packSellPrice = ref(0);
const packSellAssignmentDate = ref('');
const packSellAmountFloatType = ref(0);
const packSellTaxTotalType = ref(0);
const defaultPackSellAmountFloatType = ref(0);
const defaultPackSellTaxTotalType = ref(0);
const establishPermitFile = ref(new Object());
const establishPermitNumber = ref('');
const establishPermitExpireDate = ref('');
const onChangeEstablishPermitNumber = (value) => {
  establishPermitNumber.value = value;
}
const onChangeEstablishPermitExpireDate = (value) => {
  establishPermitExpireDate.value = value;
}
const onEstablishPermitFileUpload = (e) => {
  establishPermitFile.value = e.target.files[0];
}

const onChangePackeSellNumber = (value) => {
  packSelleNumber.value = value;
}
const onChangePackSellPrice = (value) => {
  packSellPrice.value = value;
}
const onChangePackSellAssignmentDate = (value) => {
  packSellAssignmentDate.value = value;
}
const onChangePackSellAmountFloatType = (value) => {
  packSellAmountFloatType.value = value;
}
const onChangePackSellTaxTotalType = (value) => {
  packSellTaxTotalType.value = value;
}
const showPharmacyMedicinePackSell = (medicine) => {
  establishPermitFile.value = null;
  pharmacyMedicinePackData.splice(0);
  packSellTargetPharmacy.splice(0);
  pharmacyMedicinePackData.push(medicine);
  pharmacyMedicinePackSellId.value = medicine.medicine_id;
  packSelleNumber.value = 0;
  isPharmacyMedicinePackSellDialog.value = true;
}
const closePharmacyMedicinePackSell = () => {
  isPharmacyMedicinePackSellDialog.value = false;
}
const updatePharmacyMedicinePackSell = async () => {
  if (packSelleNumber.value == 0) {
    errorAlert('数量は必須です。');
    return;
  }
  if (packSelleNumber.value < 0) {
    errorAlert('数量にマイナスは許可されていません。');
    return;
  }
  if (packSellPrice.value == 0) {
    errorAlert('単価は必須です。');
    return;
  }
  if (packSellAssignmentDate.value.length == 0) {
    errorAlert('譲受譲渡日は必須です。');
    return;
  }
  let params = new FormData();
  params.append('medicine_id', pharmacyMedicinePackData[0].medicine_id);
  params.append('number', packSelleNumber.value);
  params.append('price', packSellPrice.value);
  params.append('assignment_date', packSellAssignmentDate.value);
  params.append('target_pharmacy_id', packSellTargetPharmacy[0].id);
  params.append('medicine_group_id', packSellPharmacyGroupId.value);
  params.append('amount_float_type', packSellAmountFloatType.value);
  params.append('tax_total_type', packSellTaxTotalType.value);
  params.append('target_pharmacy_id', packSellTargetPharmacy[0].id);
  params.append('establish_permit_number', establishPermitNumber.value);
  params.append('establish_permit_expire_date', establishPermitExpireDate.value);
  params.append('establish_permit_file', establishPermitFile.value);
  params.append('is_new_only', 1);
  isPharmacyMedicinePackSellLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_pack_sell_update,{method:"post",data:params});
    if (response.data.status == 200) {
      closePharmacyMedicinePackSell();
      listSearch(config.LIST_DELAY);
    }
  } finally {
    isPharmacyMedicinePackSellLoading.value = false;
  }
}
const isTargetPharmacyDialog = ref(false);
const showTargetPharmacyDialog = async () => {
  pharmacyRelationOptions.medicine_id = pharmacyMedicinePackSellId.value;
  isTargetPharmacyDialog.value = true;
}
const closeTargetPharmacyDialog = () => {
  isTargetPharmacyDialog.value = false;
}
const commitPharmacy = (item:Object,groupId,groupName) => {
  packSellPharmacyGroupId.value = groupId;
  packSellPharmacyGroupName.value = groupName;
  packSellTargetPharmacyId.value = item.id;
  closeTargetPharmacyDialog();
  getPharmacyPackSellDetail();
}
const pharmacyRelationOptions = reactive({
  page_size:30,
  medicine_id:0,
  is_pack_sell:1,
});
const commitPharmacyHistory = (item) => {
  if (item.pharmacy == null) {
    errorAlert('薬局データが存在しないため選択出来ません。');
    return;
  }
  packSellPharmacyGroupId.value = item.medicine_group_id;
  packSellPharmacyGroupName.value = item.medicine_group_name;
  packSellTargetPharmacyId.value = item.id;
  closeTargetPharmacyDialog();
  getPharmacyPackSellDetail();
}

const getPharmacyPackSellDetail = async () => {
  isPharmacyMedicinePackSellLoading.value = true;
  packSellTargetPharmacy.splice(0);
  let params = {'medicine_id': pharmacyMedicinePackSellId.value,'target_pharmacy_id': packSellTargetPharmacyId.value,'medicine_group_id':packSellPharmacyGroupId.value};
  const paramsSerializer = (params) => qs.stringify(params);
  try {
    const response = await axios.get(props.apis.pharmacy_medicine_detail,{params:params,paramsSerializer});
    packSellPrice.value = response.data.data.recent_unit_price;
    packSellTaxTotalType.value = response.data.data.tax_total_type;
    defaultPackSellTaxTotalType.value = response.data.data.tax_total_type;
    packSellAmountFloatType.value = response.data.data.amount_float_type;
    defaultPackSellAmountFloatType.value = response.data.data.amount_float_type;
    packSellTargetPharmacy.push(response.data.data.to_pharmacy);
    establishPermitNumber.value = response.data.data.to_pharmacy.establish_permit_number;
    establishPermitExpireDate.value = (response.data.data.to_pharmacy.establish_permit_expire_date != null ? response.data.data.to_pharmacy.establish_permit_expire_date.replace(/\//g,'-') : '');
  } finally {
    isPharmacyMedicinePackSellLoading.value = false;
  }
}
const resetPackSellDefaultSetting = () => {
  packSellTaxTotalType.value = defaultPackSellTaxTotalType.value;
  packSellAmountFloatType.value = defaultPackSellAmountFloatType.value;
}
const inputStockNumber = computed(() => {
  return (medicineId) => {
    let result = '';
    for (let i=0;i<stock.edit_stock_data.length;i++) {
      if (stock.edit_stock_data[i].medicine_id == medicineId) {
        result = stock.edit_stock_data[i].stock_number;
        break;
      }
    }
    return result;
  };
})
const inputStockDateTime = computed(() => {
  return (medicineId) => {
    let result = '';
    for (let i=0;i<stock.edit_stock_data.length;i++) {
      if (stock.edit_stock_data[i].medicine_id == medicineId) {
        result = stock.edit_stock_data[i].stock_datetime;
        break;
      }
    }
    return result;
  };
})
const inputLotNo = computed(() => {
  return (medicineId) => {
    let result = '';
    for (let i=0;i<stock.edit_stock_data.length;i++) {
      if (stock.edit_stock_data[i].medicine_id == medicineId) {
        result = stock.edit_stock_data[i].lot_no;
        break;
      }
    }
    return result;
  };
})
const inputExpireDate = computed(() => {
  return (medicineId) => {
    let result = '';
    for (let i=0;i<stock.edit_stock_data.length;i++) {
      if (stock.edit_stock_data[i].medicine_id == medicineId) {
        result = stock.edit_stock_data[i].expire_date;
        break;
      }
    }
    return result;
  };
})
const inputDeleteNumber = computed(() => {
  return (medicineId) => {
    let result = '';
    for (let i=0;i<stock.edit_delete_data.length;i++) {
      if (stock.edit_delete_data[i].medicine_id == medicineId) {
        result = stock.edit_delete_data[i].delete_number;
        break;
      }
    }
    return result;
  };
})
const inputDeleteLotNo = computed(() => {
  return (medicineId) => {
    let result = '';
    for (let i=0;i<stock.edit_delete_data.length;i++) {
      if (stock.edit_delete_data[i].medicine_id == medicineId) {
        result = stock.edit_delete_data[i].lot_no;
        break;
      }
    }
    return result;
  };
})
const inputDeleteExpireDate = computed(() => {
  return (medicineId) => {
    let result = '';
    for (let i=0;i<stock.edit_delete_data.length;i++) {
      if (stock.edit_delete_data[i].medicine_id == medicineId) {
        result = stock.edit_delete_data[i].expire_date;
        break;
      }
    }
    return result;
  };
})
const seleceDeleteReason = computed(() => {
  return (medicineId) => {
    let result = 0;
    for (let i=0;i<stock.edit_delete_data.length;i++) {
      if (stock.edit_delete_data[i].medicine_id == medicineId) {
        result = stock.edit_delete_data[i].stock_reason;
        break;
      }
    }
    return result;
  };
})
const inputSellPrice = computed(() => {
  return (medicineId) => {
    let result = '';
    for (let i=0;i<stock.edit_sell_data.length;i++) {
      if (stock.edit_sell_data[i].medicine_id == medicineId) {
        result = stock.edit_sell_data[i].reference_unit_price;
        break;
      }
    }
    return result;
  };
})

const isInputEdited = computed(() => {
  return (medicineId) => {
    let result = false;
    let editing_ids = stock.get_editing_ids();
    if (editing_ids.indexOf(medicineId) != -1) {
      result = true;
    }
    return result;
  };
})
const getEstablishFileNeed = () => {
  let result = true;
  if (packSellTargetPharmacy.length == 0) {
    return result;
  }
  if (packSellTargetPharmacy[0].establish_permit_number != null && packSellTargetPharmacy[0].establish_permit_number.length > 0 && packSellTargetPharmacy[0].is_establish_permit_expired == false) {
    result = false;
  }
  return result;
}
const isEstablishFileNeed = computed(() => {
  return getEstablishFileNeed();
})
const stockCancel = () => {
  if (isStockMode.value) {
    closeStockConfirm();
  } else if (isSellMode.value) {
    closeSellConfirm();
  } else if (isDeleteMode.value) {
    closeDeleteConfirm();
  }
}
const stockSubmit = async () => {
  if (isStockMode.value) {
    let result = await confirmAlert('<span style="color:red;">納品されたのにまだ納品確定を行っていない状態で在庫調整を行ってしまうと、在庫のズレが生じます。まだ納品確定を行っていない場合は、納品確定を行ってから在庫調整を行ってください。</span><br><br>在庫調整を行いますか？');
    if (result.isConfirmed) {
      updateStock();
    }
  } else if (isSellMode.value) {
    updateSell();
  } else if (isDeleteMode.value) {
    updateDelete();
  }
}
const isEditedCheck = () => {
  let result = false;
  if (isStockMode.value) {
    result = true;
  }
  if (isDeleteMode.value) {
    result = true;
  }
  if (isSellMode.value) {
    result = true;
  }
  return result;
}
const isEdited = computed(() => {
  setTimeout(changeListHeight,100);
  return isEditedCheck();
})

const itemMedicines = computed(() => {
  return (item,fromIndex = null,toIndex = null) => {
    let result = [];
    if (typeof item !== 'undefined' && typeof item.medicines !== 'undefined') {
      for (let i=0;i<item.medicines.length;i++) {
        if (fromIndex != null && i < fromIndex) {
          continue;
        }
        if (toIndex != null && i > toIndex) {
          continue;
        }
        result.push(item.medicines[i]);
      }
    }
    return result;
  };
})

const onChangeDrugType = (value,option) => {
  if (value) {
    if (drugTypes.indexOf(option.drug_type) == -1) {
      drugTypes.push(option.drug_type);
    }
  } else {
    if (drugTypes.indexOf(option.drug_type) != -1) {
      drugTypes.splice(drugTypes.indexOf(option.drug_type),1);
    }
  }
  listSearch();
}
const checkDrugType = computed(() => {
  return (drug_type) => {
    return drugTypes.indexOf(drug_type) == -1 ? false : true;
  }
})
const isPackCancelDialog = ref(false);
const isPackCancelLoading = ref(false);
const packCancelMedicineName = ref('');
const packCancelMedicineId = ref(0);
const packCancelNumber = ref(0);
const packCancelReason = ref('');
const showPackCancelDialog = (medicine) => {
  packCancelMedicineId.value = medicine.medicine_id;
  packCancelMedicineName.value = medicine.product_name + ' ' + medicine.package_label;
  isPackCancelDialog.value = true;
}
const closePackCancelDialog = () => {
  isPackCancelDialog.value = false;
}
const onChangePackCancelNumber = (value) => {
  packCancelNumber.value = value;
}
const onChangePackCancelReason = (value) => {
  packCancelReason.value = value;
}
const updatePackCancel = async () => {
  if (!packCancelNumber.value) {
    errorAlert('取消数量は必須です。')
    return;
  }
  if (packCancelNumber.value < 0) {
    errorAlert('取消数量は正の数字で入力してください。')
    return;
  }
  if (!packCancelReason.value) {
    errorAlert('取消理由は必須です。')
    return;
  }
  let params = new FormData();
  params.append('medicine_id',packCancelMedicineId.value);
  params.append('pack_cancel_number',packCancelNumber.value);
  params.append('pack_cancel_reason',packCancelReason.value);
  isPackCancelLoading.value = true;
  try {
    const response = await axios(props.apis.pharmacy_pack_cancel_update,{method:"post",data:params});
    if (response.data.status == 200) {
      closePackCancelDialog();
      listSearch(config.LIST_DELAY);
    }
  } finally {
    isPackCancelLoading.value = false;
  }
}
// 発注メニューの開閉管理status
const isOpen = ref(false);
// モバイルのみ表示する為のstatus
const isMobile: boolean = Breakpoint().isBelow('sm');

// 発注メニューの開閉管理
const toggleAccordion = () => {
  isOpen.value = !isOpen.value;;
}
/////// 検索機能追加 ////////////
const onMedicineSelectChange = (values) => {
    medicineIds.splice(0);
    for (let i=0;i<values.length;i++) {
        medicineIds.push(values[i]);
    }
    listSearch();
}
///////////////////////////////
////// タグ機能//////////////////////////
const onPharmacyTagChange = (tags) => {
    pharmacyTagList.splice(0);
    for (let i=0;i<tags.length;i++) {
        pharmacyTagList.push(tags[i]);
    }
    listSearch();
}
const onChangePharmacyMedicineTag = (pharmacyMedicineId,tags) => {
  let item = listRef.value.getItemById(pharmacyMedicineId);
  if (item != null) {
    item.tags = tags;
  }
}
////////////////////////////////////////
</script>

<style scoped>
</style>
<template>
<div ref="element" class="relative">
  <div class="p-1">
    <help-action
      help-key="stock_help"
    ></help-action>
  </div>
  <div class="w-full md:flex items-center justify-end">
    <div ref="headerRef" class="md:w-auto md:flex items-center justify-end px-2  md:border-none rounded">
      <div v-for="drug_type in Object.keys(config.DRUG_TYPES)" :key="drug_type" class="mr-1">
        <check-box
          :label="config.DRUG_TYPES[drug_type]"
          :value="checkDrugType(drug_type)"
          :value-options="{drug_type:drug_type}"
          :on-change="onChangeDrugType"
        ></check-box>
      </div>
      <div v-if="isMobile" class="w-full md:flex items-center justify-end pt-2 md:p-2 border-b">
        <button  @click="toggleAccordion" class="flex items-center justify-center w-full py-2 px-4 text-gray-800 border-t border-x text-left">
          <img class="w-7 h-7" src="../../../../public/images/icon/refine_search.png" alt="絞り込み検索">
          <div class="mx-3">絞り込み検索</div>
          <div class="pull-down-icon" :class="{ 'rotate-180': isOpen }"></div>
        </button>
      </div>
      <div v-if="!isMobile || isOpen" class="md:flex border-x border-b md:border-none items-center p-2.5 justify-end">
          <div class="m-1 flex flex-row items-center">
            <span class="text-xl mr-2"><i class="fa-solid fa-tag"></i></span>
            <select-box
                :api-url="apis.pharmacy_tag_list"
                :api-option-fields="{page_size:1000}"
                :on-change="onPharmacyTagChange"
                :value="pharmacyTagList"
                list-field-name="tag_name"
                :options="pharmacyTagOptions"
                :is-multi="true"
                place-holder="タグを選択"
                list-height="20em"
            ></select-box>
          </div>
          <div class="md:m-1">
            <select-box
                :api-url="apis.medicine_list"
                :api-option-fields="{relation_pharmacy:1,is_relation:1,page_size:20}"
                :on-change="onMedicineSelectChange"
                :value="medicineIds"
                list-field-name="product_detail_name"
                :options="medicineOptions"
                :is-multi="true"
                place-holder="採用品を選択"
                list-height="20em"
            ></select-box>
        </div>
        <div class="w-fit mx-1 md:m-1">
          <search-box
            :search-word="searchWord"
            :on-change="onSearchWordChange"
            :on-enter="onSearchWordEnter"
            place-holder="採用品名を入力"
          ></search-box>
        </div>
        <!--
        <div class="m-1 flex flex-row items-center">
          <text-box
            :value="searchDateFrom"
            type="date"
            :on-change="onSearchDateFromChange"
            place-holder="日付を入力"
          ></text-box>
          <div class="tex-lg">~</div>
          <text-box
            :value="searchDateTo"
            type="date"
            :on-change="onSearchDateToChange"
            place-holder="日付を入力"
          ></text-box>
          <a @click="clearDate" class="block cursor-pointer m-1 text-lg text-red-500"><i class="fa-solid fa-calendar-xmark"></i></a>
        </div>
        -->
      </div>
    </div>
    <div class="w-full md:w-auto flex flex-wrap items-center justify-end p-2">
      <div class="m-1">
          <a href="javascript:void(0)" @click="editStock" :class="(isStockMode ? 'text-black bg-gray-200' : 'text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200') + ' block font-medium rounded-lg text-xs md:text-base px-4 py-1 w-full sm:w-auto text-center ml-2'">棚卸</a>
      </div>
      <div class="m-1">
        <a href="javascript:void(0)" @click="editDelete" :class="(isDeleteMode ? 'text-black bg-gray-200' : 'text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200') + ' block font-medium rounded-lg text-xs md:text-base px-4 py-1 w-full sm:w-auto text-center ml-2'">廃棄</a>
      </div>
      <div class="m-1">
        <a href="javascript:void(0)" @click="showEditPharmacyMedicine" :class="(isEdited ? 'text-black bg-gray-200' : 'text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200') + ' block font-medium rounded-lg text-xs md:text-base px-4 py-1 w-full sm:w-auto text-center ml-2'">採用品追加</a>
      </div>
      <div class="m-1">
        <a href="javascript:void(0)" @click="showUploadFileDialog" :class="(isEdited ? 'text-black bg-gray-200' : 'text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200') + ' block font-medium rounded-lg text-xs md:text-base px-4 py-1 w-full sm:w-auto text-center ml-2'">棚卸ファイル</a>
      </div>
    </div>
  </div>
  <div class="w-full mb-10">
      <custom-list
        ref="listRef"
        :table-fields="fields"
        :option-fields="optionFields"
        :api-url="apis.pharmacy_medicine_stock_list"
        :height="listHeight + 'px'"
        :is-cell-join="true"
        list-key="yj_code"
        :handler="handler"
      >
      <template v-slot:item="slotProps">
        <tr class="border-b border-gray-400">
          <td v-for="(field,index) in mainFields" :rowspan="itemMedicines(slotProps.item).length" :key="index" :style="'width:' + field.width" :class="'text-center'">
            <div v-if="field.field_key == 'product_name'" :class="field.align">
              <a href="javascript:void(0)" @click="showStockHistory(slotProps.item)" class="p-0.5 md:p-0 block text-amber-700">{{ slotProps.item.product_name }}</a>
                  <pharmacy-medicine-tag-component
                    :tags="slotProps.item.tags"
                    :apis="apis"
                    :pharmacy-medicine-id="slotProps.item.id"
                    :submit="onChangePharmacyMedicineTag"
                  ></pharmacy-medicine-tag-component>
            </div>
            <div v-else-if="field.field_key == 'real_stock_number'" :class="field.align">
              {{ slotProps.item.real_stock_number.toLocaleString() + slotProps.item.package_unit }}
            </div>
            <div v-else-if="field.field_key == 'warning_mark'" :class="field.align">
              <span v-html="slotProps.item.warning_mark"></span>
            </div>
            <div v-else-if="field.field_key == 'stock_number'" :class="field.align">
              <span :class="(slotProps.item.real_stock_number != slotProps.item.stock_number ? ' text-red-700 text-bold ' : '')">{{ getFieldValue(slotProps.item,field.field_key).toLocaleString() + slotProps.item.package_unit }}</span>
            </div>
          </td>
          <td v-if="itemMedicines(slotProps.item).length > 0" v-for="(detailField,index2) in detailFields" :key="index2" :style="'width:' + detailField.width" :class="'text-center' + (itemMedicines(slotProps.item)[0].is_deleted ? ' bg-gray-200 ' : '')">
            <div v-for="(medicine,index3) in itemMedicines(slotProps.item,0,0)" :key="index3">
              <div v-if="detailField.field_key == 'package_label'" :class="detailField.align">
                <a href="javascript:void(0)" @click="showStockHistory(medicine)" class="p-0.5 md:p-0 block text-amber-700">{{ medicine.package_label }} <span v-html="medicine.is_head_managed ? getHeadMedicineMark() : ''"></span></a>
              </div>
              <div v-else-if="detailField.field_key == 'storage_bin'" :class="detailField.align">
                {{ medicine.storage_bin }}
              </div>
              <div v-else-if="detailField.field_key == 'medicine_real_stock_number'" :class="detailField.align">
                {{ medicine.real_stock_number.toLocaleString() + medicine.package_unit }}<br>
                <a href="javascript:void(0)" @click="showPharmacyMedicinePackSell(medicine)" class="block text-gray-900 focus:outline-none bg-white m-1 py-1 px-2 text-xs font-medium rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">小分け</a>
                <!--<a href="javascript:void(0)" @click="showPackCancelDialog(medicine)" class="block text-white focus:outline-none bg-red-600 m-1 py-1 px-2 text-xs font-medium rounded-full border border-red-600 hover:bg-red-500 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">小分け販売取消</a>-->
              </div>
              <div v-else-if="detailField.field_key == 'medicine_stock_number'" :class="detailField.align">
                <span :class="(medicine.real_stock_number != medicine.stock_number ? ' text-red-700 text-bold ' : '')">{{ medicine.stock_number.toLocaleString() + itemMedicines(slotProps.item)[0].package_unit }}</span>
              </div>
              <div v-else-if="detailField.field_key == 'latest_inventory_date'" :class="detailField.align" v-html="medicine.latest_inventory_date != null ? medicine.latest_inventory_date.replace(' ','<br>') : ''">
              </div>
              <div v-else-if="detailField.field_key == 'latest_access_date'" :class="detailField.align" v-html="medicine.latest_access_date != null ? medicine.latest_access_date.replace(' ','<br>') : ''">
              </div>
              <div v-else-if="detailField.field_key == 'action_setting' && !isEdited">
                <a href="javascript:void(0)" @click="showEditPharmacyMedicine(medicine)"><i class="fa-solid fa-gear"></i></a>
              </div>
              <div v-else-if="detailField.field_key == 'action_stock'" :class="detailField.align + (isInputEdited(medicine.medicine_id) ? ' border border-blue-600' : '')">
                <div class="border p-1 relative flex flex-row items-center">
                  <div class="">
                    <text-box
                      ref="inputRefs"
                      type="number"
                      :identity-id="String(medicine.medicine_id)"
                      :value="inputStockNumber(medicine.medicine_id)"
                      :value-options="{medicine_id:medicine.medicine_id}"
                      :on-change="editStockTextChange"
                      :is-focus-clear="true"
                    ></text-box>
                  </div>
                  <div :class="'ml-1 ' + (isInputEdited(medicine.medicine_id) && inputStockDateTime(medicine.medicine_id).length == 0 ? 'border border-red-600' : '')">
                    <text-box
                      ref="inputRefs"
                      type="datetime-local"
                      :identity-id="String(medicine.medicine_id)"
                      :value="inputStockDateTime(medicine.medicine_id)"
                      :value-options="{medicine_id:medicine.medicine_id}"
                      :on-change="editStockDateTimeChange"
                      :is-focus-clear="false"
                    ></text-box>
                  </div>
                </div>
                <div class="border p-1 relative flex flex-row items-center">
                  <div class="">
                    <text-box
                      ref="inputRefs"
                      type="text"
                      :is-read-only="!isInputEdited(medicine.medicine_id)"
                      :identity-id="String(medicine.medicine_id)"
                      :value="inputLotNo(medicine.medicine_id)"
                      :value-options="{medicine_id:medicine.medicine_id}"
                      :on-change="editLotNoChange"
                      place-holder="ロット番号"
                      :is-focus-clear="true"
                    ></text-box>
                  </div>
                  <div :class="'ml-1 ' + (isInputEdited(medicine.medicine_id) && inputStockDateTime(medicine.medicine_id).length == 0 ? 'border border-red-600' : '')">
                    <!-- year_month -->
                    <text-box
                      ref="inputRefs"
                      type="year_month"
                      :is-read-only="!isInputEdited(medicine.medicine_id)"
                      :identity-id="String(medicine.medicine_id)"
                      :value="inputExpireDate(medicine.medicine_id)"
                      :value-options="{medicine_id:medicine.medicine_id}"
                      :on-change="editExpireDateChange"
                      place-holder="有効期限"
                      :is-focus-clear="false"
                    ></text-box>
                  </div>
                </div>
              </div>
              <div v-else-if="detailField.field_key == 'action_sell'" :class="detailField.align + (isInputEdited(medicine.medicine_id) ? ' border border-blue-600' : '')">
                <div class="border p-1 relative flex flex-wrap">
                  <div class="">
                    <text-box
                      ref="inputSellRefs"
                      type="number"
                      :identity-id="String(medicine.medicine_id)"
                      :value="inputSellPrice(medicine.medicine_id)"
                      :value-options="{medicine_id:medicine.medicine_id}"
                      :on-change="editSellTextChange"
                      :is-focus-clear="true"
                    ></text-box>
                  </div>
                </div>
              </div>
              <div v-else-if="detailField.field_key == 'action_delete'" :class="detailField.align + (isInputEdited(medicine.medicine_id) ? ' border border-blue-600' : '')">
                <div class="border p-1 relative flex flex-wrap">
                  <div class="m-1">
                    <text-box
                      ref="inputDeleteRefs"
                      type="number"
                      :identity-id="String(medicine.medicine_id)"
                      :value="inputDeleteNumber(medicine.medicine_id)"
                      :value-options="{medicine_id:medicine.medicine_id}"
                      :on-change="editDeleteTextChange"
                      :is-focus-clear="true"
                    ></text-box>
                  </div>
                  <div class="m-1">
                    <select-box
                      :value="seleceDeleteReason(medicine.medicine_id)"
                      :is-searchable="false"
                      :value-options="{medicine_id:medicine.medicine_id}"
                      :on-change="selectDeleteReasonChange"
                      :options="deleteReasons"
                    ></select-box>
                  </div>
                  <div class="m-1">
                    <text-box
                      ref="inputDeleteRefs"
                      type="text"
                      font-width="half"
                      :identity-id="String(medicine.medicine_id)"
                      :value="inputDeleteLotNo(medicine.medicine_id)"
                      :value-options="{medicine_id:medicine.medicine_id}"
                      :on-change="editDeleteLotNoTextChange"
                      :is-focus-clear="true"
                      place-holder="ロット番号"
                    ></text-box>
                  </div>
                  <div class="m-1">
                    <!-- year_month -->
                    <text-box
                      ref="inputDeleteRefs"
                      type="year_month"
                      font-width="half"
                      :identity-id="String(medicine.medicine_id)"
                      :value="inputDeleteExpireDate(medicine.medicine_id)"
                      :value-options="{medicine_id:medicine.medicine_id}"
                      :on-change="editDeleteExpireDateTextChange"
                      :is-focus-clear="true"
                      place-holder="有効期限"
                    ></text-box>
                  </div>
                </div>
              </div>
              <div v-else :class="detailField.align">
                {{ medicine[detailField.field_key] }}
              </div>
            </div>
          </td>
        </tr>
        <tr class="border-b border-gray-400" v-for="(medicine,index) in itemMedicines(slotProps.item,1)" :key="index">
          <td v-for="(detailField,index2) in detailFields" :key="index2" :style="'width:' + detailField.width" :class="'text-center' + (medicine.is_deleted ? ' bg-gray-200 ' : '')">
            <div v-if="detailField.field_key == 'package_label'" :class="detailField.align">
              <a href="javascript:void(0)" @click="showStockHistory(medicine)" class="p-0.5 md:p-0 block text-amber-700">{{ medicine.package_label }}  <span v-html="medicine.is_head_managed ? getHeadMedicineMark() : ''"></span></a>
            </div>
            <div v-else-if="detailField.field_key == 'storage_bin'" :class="detailField.align">
              {{ medicine.storage_bin }}
            </div>
            <div v-else-if="detailField.field_key == 'medicine_real_stock_number'" :class="detailField.align">
              {{ medicine.real_stock_number.toLocaleString() + medicine.package_unit }}<br>
              <a href="javascript:void(0)" @click="showPharmacyMedicinePackSell(medicine)" class="block text-gray-900 focus:outline-none bg-white m-1 py-1 px-2 text-xs font-medium rounded-full border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">小分け</a>
              <!--<a href="javascript:void(0)" @click="showPackCancelDialog(medicine)" class="block text-white focus:outline-none bg-red-600 m-1 py-1 px-2 text-xs font-medium rounded-full border border-red-600 hover:bg-red-500 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">小分け販売取消</a>-->
            </div>
            <div v-else-if="detailField.field_key == 'medicine_stock_number'" :class="detailField.align">
              <span :class="(medicine.real_stock_number != medicine.stock_number ? ' text-red-700 text-bold ' : '')">{{ medicine.stock_number.toLocaleString() + medicine.package_unit }}</span>
            </div>
            <div v-else-if="detailField.field_key == 'latest_inventory_date'" :class="detailField.align" v-html="medicine.latest_inventory_date != null ? medicine.latest_inventory_date.replace(' ','<br>') : ''">
            </div>
            <div v-else-if="detailField.field_key == 'latest_access_date'" :class="detailField.align" v-html="medicine.latest_access_date != null ? medicine.latest_access_date.replace(' ','<br>') : ''">
            </div>
            <div v-else-if="detailField.field_key == 'action_setting' && !isEdited">
              <a href="javascript:void(0)" @click="showEditPharmacyMedicine(medicine)"><i class="fa-solid fa-gear"></i></a>
            </div>
            <div v-else-if="detailField.field_key == 'action_stock'" :class="detailField.align + (isInputEdited(medicine.medicine_id) ? ' border border-blue-600' : '')">
              <div class="border p-1 relative flex flex-row items-center">
                <div class="">
                  <text-box
                    ref="inputRefs"
                    type="number"
                    :identity-id="String(medicine.medicine_id)"
                    :value="inputStockNumber(medicine.medicine_id)"
                    :value-options="{medicine_id:medicine.medicine_id}"
                    :on-change="editStockTextChange"
                    :is-focus-clear="true"
                  ></text-box>
                </div>
                <div :class="'ml-1 ' + (isInputEdited(medicine.medicine_id) && inputStockDateTime(medicine.medicine_id).length == 0 ? 'border border-red-600' : '')">
                  <text-box
                    ref="inputRefs"
                    type="datetime-local"
                    :identity-id="String(medicine.medicine_id)"
                    :value="inputStockDateTime(medicine.medicine_id)"
                    :value-options="{medicine_id:medicine.medicine_id}"
                    :on-change="editStockDateTimeChange"
                    :is-focus-clear="false"
                  ></text-box>
                </div>
              </div>
            </div>
            <div v-else-if="detailField.field_key == 'action_sell'" :class="detailField.align + (isInputEdited(medicine.medicine_id) ? ' border border-blue-600' : '')">
              <div class="border p-1 relative flex flex-wrap">
                <div class="">
                  <text-box
                    ref="inputSellRefs"
                    type="number"
                    :identity-id="String(medicine.medicine_id)"
                    :value="inputSellPrice(medicine.medicine_id)"
                    :value-options="{medicine_id:medicine.medicine_id}"
                    :on-change="editSellTextChange"
                    :is-focus-clear="true"
                  ></text-box>
                </div>
              </div>
            </div>
            <div v-else-if="detailField.field_key == 'action_delete'" :class="detailField.align + (isInputEdited(medicine.medicine_id) ? ' border border-blue-600' : '')">
              <div class="border p-1 relative flex flex-wrap">
                <div class="m-1">
                  <text-box
                    ref="inputDeleteRefs"
                    type="number"
                    :identity-id="String(medicine.medicine_id)"
                    :value="inputDeleteNumber(medicine.medicine_id)"
                    :value-options="{medicine_id:medicine.medicine_id}"
                    :on-change="editDeleteTextChange"
                    :is-focus-clear="true"
                  ></text-box>
                </div>
                <div class="m-1">
                  <select-box
                    :value="seleceDeleteReason(medicine.medicine_id)"
                    :value-options="{medicine_id:medicine.medicine_id}"
                    :on-change="selectDeleteReasonChange"
                    :options="deleteReasons"
                  ></select-box>
                </div>
                <div class="m-1">
                  <text-box
                    ref="inputDeleteRefs"
                    type="text"
                    font-width="half"
                    :identity-id="String(medicine.medicine_id)"
                    :value="inputDeleteLotNo(medicine.medicine_id)"
                    :value-options="{medicine_id:medicine.medicine_id}"
                    :on-change="editDeleteLotNoTextChange"
                    :is-focus-clear="true"
                    place-holder="ロット番号"
                  ></text-box>
                </div>
                <div class="m-1">
                  <!-- year_month -->
                  <text-box
                    ref="inputDeleteRefs"
                    type="year_month"
                    font-width="half"
                    :identity-id="String(medicine.medicine_id)"
                    :value="inputDeleteExpireDate(medicine.medicine_id)"
                    :value-options="{medicine_id:medicine.medicine_id}"
                    :on-change="editDeleteExpireDateTextChange"
                    :is-focus-clear="true"
                    place-holder="有効期限"
                  ></text-box>
                </div>
              </div>
            </div>
            <div v-else :class="detailField.align">
              {{ medicine[detailField.field_key] }}
            </div>
          </td>
        </tr>
      </template>
      </custom-list>
  </div>
  <div ref="submitRef" v-show="isEdited" class="fixed bottom-0 right-0 w-full flex items-center justify-end flex-wrap p-2 bg-gray-100 rounded">
    <a href="javascript:void(0)" @click="stockCancel" class="flex py-2.5 px-5 m-2 text-base font-medium text-white focus:outline-none bg-red-800 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">キャンセル</a>
    <button type="button" @click="stockSubmit" class="py-2.5 px-5 m-2　text-base font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">確定</button>
  </div>
</div>
<modal-dialog
  :is-visible="isStockDialog"
  width="90%"
  :close="closeStockHistory"
>
  <template v-slot:header>
    採用品履歴
  </template>
  <template v-slot:default>
    <medicine-history-detail-component
      :apis="apis"
      :search-key="stockMedicineId > 0 ? stockMedicineId : stockMedicineYjCode"
      :search-key-field="stockMedicineId > 0 ? 'medicine_id' : 'yj_code'"
    ></medicine-history-detail-component>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isPharmacyMedicinePackSellDialog"
  :close="closePharmacyMedicinePackSell"
  :isLoading="isPharmacyMedicinePackSellLoading"
>
  <template v-slot:header>
    小分け販売
  </template>
  <template v-slot:default>
    <div class="md:border p-2">
      <div class="p-1 flex flex-col justify-items-start" v-for="pack_medicine in pharmacyMedicinePackData" :key="pack_medicine.medicine_id">
        <div class="w-full m-1 whitespace-pre-wrap">
          {{ pack_medicine.product_detail_name }}
        </div>
        <div class="w-full m-1">
          実在庫数：{{ pack_medicine.real_stock_number.toLocaleString() + ' ' + pack_medicine.package_unit }} 仮在庫数：{{ pack_medicine.stock_number.toLocaleString() + ' ' + pack_medicine.package_unit }}
        </div>
      </div>
    </div>
    <div class="md:border p-2 flex flex-row items-center">
      <div class="m-1">
        <button type="button" @click="showTargetPharmacyDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">取引先薬局選択</button>
      </div>
      <div class="m-1">
        <div class="p-1" v-for="pharmacy in packSellTargetPharmacy" :key="pharmacy.id">
          <div class="flex flex-row items-center">
            <div class="m-1">
              <div class="flex flex-row items-center">
                <div>{{ packSellPharmacyGroupName + ' ' + pharmacy.pharmacy_name }}</div>
              </div>
            </div>
            <a v-show="pharmacy.establish_permit_url.length > 0" :href="pharmacy.establish_permit_url" target="blank" class="block cursor-pointer text-black bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-4 py-1 w-full sm:w-auto text-center ml-2">開設許可証</a>
          </div>
          <div v-if="isEstablishFileNeed == false">
            <div>開設許可証番号：{{ pharmacy.establish_permit_number }}</div>
            <div>開設許可証有効期限：{{ pharmacy.establish_permit_expire_date }}</div>
          </div>
          <div v-else>
            <table class="w-full">
              <tr class="border-b border-white">
                <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">開設許可証</th>
                <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
                  <input class="appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="file" @change="onEstablishPermitFileUpload">
                  <p>前回アップロード日時：{{ pharmacy.establish_permit_upload_date }}</p>
                </td>
              </tr>
              <tr class="border-b border-white">
                <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">開設許可証番号</th>
                <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
                  <text-box
                    type="text"
                    :value="establishPermitNumber"
                    :on-change="onChangeEstablishPermitNumber"
                  ></text-box>
                </td>
              </tr>
              <tr class="border-b border-white">
                <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">開設許可証有効期限</th>
                <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
                  <text-box
                    type="date"
                    :value="establishPermitExpireDate"
                    :on-change="onChangeEstablishPermitExpireDate"
                  ></text-box>
                </td>
              </tr>
            </table>
          </div>
          <div>TEL:{{ pharmacy.pharmacy_telephone }} FAX:{{ pharmacy.pharmacy_fax }}</div>
          <div>営業時間：<span class="crlf-area">{{ pharmacy.pharmacy_business_hour }}</span></div>
        </div>
      </div>
    </div>
    <div v-show="packSellTargetPharmacy.length > 0" class="md:border p-2 flex flex-row items-center">
      <div class="p-1 flex flex-col justify-items-start">
        <div class="m-1 flex flex-row items-center">
          <div class="m-1 flex flex-row items-center">
            <div>合計金額条件：</div>
            <div>
              <div>
                <select-box
                  :value="packSellTaxTotalType"
                  :options="config.TAX_TOTAL_TYPES"
                  width="280px"
                  :on-change="onChangePackSellTaxTotalType"
                ></select-box>
              </div>
            </div>
          </div>
          <div class="m-1 flex flex-row items-center">
            <div>小数点の扱い：</div>
            <div>
              <div>
                <select-box
                  :value="packSellAmountFloatType"
                  :options="config.AMOUNT_FLOAT_TYPES"
                  :on-change="onChangePackSellAmountFloatType"
                ></select-box>
              </div>
            </div>
          </div>
          <div class="ml-1">
            <a href="javascript:void(0)" @click="resetPackSellDefaultSetting"><i class="fa-solid fa-rotate-left"></i></a>
          </div>
        </div>
        <div class="m-1">
          <div class="m-1 flex flex-row items-center">
            <div class="m-1">譲受譲渡日：</div>
            <div class="m-1">
              <text-box
                :value="packSellAssignmentDate"
                type="date"
                :on-change="onChangePackSellAssignmentDate"
              ></text-box>
            </div>
          </div>
        </div>
        <div class="m-1">
          <div class="m-1 flex flex-row items-center">
            <div class="m-1">単価：</div>
            <div class="m-1">
              <text-box
                :value="packSellPrice"
                :is-focus-clear="true"
                type="number"
                :on-change="onChangePackSellPrice"
              ></text-box>
            </div>
            <div class="m-1">
              販売数：
            </div>
            <div class="m-1">
              <text-box
                :value="packSelleNumber"
                :is-focus-clear="true"
                type="number"
                :on-change="onChangePackeSellNumber"
              ></text-box>
            </div>
            <div class="m-1" v-for="pack_medicine in pharmacyMedicinePackData" :key="pack_medicine.medicine_id">{{ pack_medicine.package_unit }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="flex">
      <div class="flex-row mr-2">
        <button type="button" @click="updatePharmacyMedicinePackSell" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録する</button>
      </div>
      <div class="flex-row">
        <button type="button" @click="closePharmacyMedicinePackSell" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
      </div>
    </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isTargetPharmacyDialog"
  :close="closeTargetPharmacyDialog"
>
  <template v-slot:header>
    取引先薬局選択
  </template>
  <template v-slot:default>
    <div class="mb-6">
      <!-- TODO
      <span class="text-sm">現在在庫のある過去の取引先</span>
      <custom-list
        ref="listPharmacyRelationRef"
        :option-fields="pharmacyRelationOptions"
        :api-url="apis.pharmacy_relation_history_list"
        height="100px"
        width="100%"
      >
      <template v-slot:item="slotProps">
        <div class="w-full flex items-center justify-between" @click="commitPharmacyHistory(slotProps.item)">{{ slotProps.item.medicine_group_name }} {{ slotProps.item.pharmacy_name }}({{ slotProps.item.pharmacy_prefecture }})<div v-show="slotProps.item.pharmacy.old_medicine_count > 0"> <img class="w-6 h-6" src="../../../../public/images/icon/icon_old_medicine_alert.png"></div></div>
      </template>
      </custom-list>
      -->
      <pharmacy-group-list-component
        :apis="apis"
        type="is_pack"
        :medicine-id="pharmacyMedicinePackSellId"
        :on-select-pharmacy="commitPharmacy"
        :is-pack-sell="true"
      ></pharmacy-group-list-component>
    </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isEditPharmacyMedicineDialog"
  width="95%"
  :close="closeEditPharmacyMedicine"
>
  <template v-slot:header>
    採用品編集
  </template>
  <template v-slot:default>
    <pharmacy-medicine-edit-component
      :apis="apis"
      :yj-code="yjCode"
      :pharmacy-wholesalers="pharmacyWholesalers"
      :is-medicine-fix="yjCode ? true : false"
      :is-deletable="true"
      :cancel="closeEditPharmacyMedicine"
      :updateComplete="updateCompleteMedicine"
    ></pharmacy-medicine-edit-component>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isEditLoading"
  width="40%"
  :isLoading="true"
>
  <template v-slot:header>
  </template>
  <template v-slot:default>
  <div class="mb-6">
    処理中です。
  </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isUploadFileDialog"
  width="60%"
  :close="closeUploadFileDialog"
  :isLoading="isUploadFileLoading"
>
  <template v-slot:header>
    棚卸ファイル読み込み
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <div class="mb-3 px-3 py-2 md:mb-0 md:rounded-t">
      <p class="text-lg font-bold">現時点の在庫データをダウンロード出来ます。</p>
      <a :href="apis.pharmacy_stock_download + '?medicine_type=' + isMedicineType" target="blank" class="inline-block bg-amber-300 hover:bg-amber-400 focus:ring-4 focus:ring-amber-200 font-medium rounded-lg text-base px-4 py-1 w-full sm:w-auto text-center mt-2">棚卸データダウンロード</a>
      <check-box
        label='毒薬・劇薬・向精神薬・麻薬/覚醒のみ'
        :value="isMedicineType"
        :on-change="editCheckChange"
      ></check-box>
    </div>
    <div class="mb-3 px-3 py-2 md:mb-0 md:rounded-t">
      <p class="text-lg font-bold">読み込み設定</p>
    </div>
    <div class="md:border p-2">
      <table class="w-full">
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">
            棚卸ファイル選択(CSVファイル)
          </th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <span class="text-red-700">※アップロードするファイルは、「棚卸データダウンロード」でダウンロードしたファイルに追記したものをアップロードしてください。<br>列を並び替えたり列を削除したり、ヘッダの列名を変更した場合、予測外のデータを取り込んでしまう可能性がありますので十分ご注意ください。</span>
            <csv-loader
              :value="uploadFile"
              :handler="uploadFilehandler"
              :loadStart="uploadStart"
              :loadComplete="uploadComplete"
            ></csv-loader>
          </td>
        </tr>
      </table>
    </div>
    <div class="md:border p-2 h-40 overflow-auto">
      <table class="table-auto whitespace-nowrap min-w-full border text-center">
        <tr class="bg-white border-b " v-for="(csvData,index1) in uploadFileData" :key="index1">
          <td class="border-r bg-gray-400">
            {{ index1+1 }}
          </td>
          <td class="border-r" v-for="(csv,index2) in csvData" :key="index2">
            {{ csv }}
          </td>
        </tr>
      </table>
    </div>
    <div class="flex flex-col item-center md:w-auto">
      <div><span>棚卸を行った日時を指定してください。</span></div>
      <div class="md:w-2/5">
        <text-box
          :value="updateStockDate"
          type="datetime-local"
          :on-change="changeUpdateStockDate"
        ></text-box>
      </div>
    </div>
    <div class="flex">
      <div class="flex-row mr-2">
        <button type="button" @click="uploadFileDataResultConfirm" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">取り込む</button>
      </div>
      <div class="flex-row">
        <button type="button" @click="closeUploadFileDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
      </div>
    </div>
  </div>
  </template>
</modal-dialog>

<modal-dialog
  :is-visible="isPackCancelDialog"
  width="50%"
  :close="closePackCancelDialog"
  :isLoading="isPackCancelLoading"
>
  <template v-slot:header>
    小分け販売取消
  </template>
  <template v-slot:default>
  <div class="mb-6">
    <div class="flex flex-col">
      <p>{{ packCancelMedicineName }}</p>
      <table class="w-full">
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">取消数量</th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <text-box
              :value="packSelleNumber"
              :is-focus-clear="true"
              type="number"
              :on-change="onChangePackCancelNumber"
            ></text-box>
          </td>
        </tr>
        <tr class="border-b border-white">
          <th class="block px-3 py-2 bg-gray-200 text-left md:table-cell md:w-1/3 md:text-sm">取消理由</th>
          <td class="block py-3 text-sm md:table-cell md:w-2/3 md:px-3 md:py-2">
            <text-box
              :value="packCancelReason"
              :is-focus-clear="false"
              type="textarea"
              :on-change="onChangePackCancelReason"
              :text-area-rows="4"
              placeholder="削除理由を入力してください。"
            ></text-box>
          </td>
        </tr>
      </table>
      <div class="flex flex-row items-center justify-center">
        <div class="flex-row mr-2">
          <button type="button" @click="updatePackCancel" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-full border border-gray-200 hover:bg-amber-300 hover:text-black focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">登録する</button>
        </div>
        <div class="flex-row">
          <button type="button" @click="closePackCancelDialog" class="w-full py-2.5 px-5 mr-2 my-2 text-sm font-medium text-white focus:outline-none bg-red-700 rounded-full border border-gray-200 hover:bg-red-600 hover:text-white focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-red-600 dark:hover:text-white dark:hover:bg-red-700">キャンセル</button>
        </div>
      </div>
    </div>
  </div>
  </template>
</modal-dialog>

</template>

